import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg, formatDate } from "@/lib/api";
import { StatusBadge } from "@/components/shop/StatusBadge";
import { OrderSummary } from "@/pages/Payment";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const STEPS = ["pending", "paid", "packed", "shipped", "completed"];

export const Timeline = ({ status }) => {
  const idx = STEPS.indexOf(status);
  return (
    <ol className="flex gap-1" data-testid="order-timeline">
      {STEPS.map((s, i) => (
        <li key={s} className="flex-1">
          <div className={`h-1.5 rounded-full ${i <= idx ? "bg-amber-700" : "bg-stone-200"}`} />
          <p className={`mt-1 text-[11px] ${i <= idx ? "text-stone-900" : "text-stone-400"}`}>{s[0].toUpperCase() + s.slice(1)}</p>
        </li>
      ))}
    </ol>
  );
};

export default function Track() {
  const [orderId, setOrderId] = useState("");
  const [phone, setPhone] = useState("");
  const [o, setO] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr(""); setO(null);
    try { setO((await api.get("/orders/track", { params: { order_id: orderId, phone } })).data); }
    catch (ex) { setErr(errMsg(ex, "Pesanan tidak ditemukan")); }
    finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-10 md:px-6">
      <h1 className="text-3xl font-semibold">Lacak Pesanan</h1>
      <p className="mt-2 text-sm text-stone-600">Masukkan nomor pesanan dan nomor WhatsApp yang dipakai saat checkout.</p>
      <form onSubmit={submit} className="mt-6 grid gap-4 rounded-lg border border-stone-200 bg-white p-5 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
        <div className="space-y-1.5"><Label htmlFor="t-id">No. Pesanan</Label><Input id="t-id" data-testid="track-order-id-input" required placeholder="EM2611..." value={orderId} onChange={(e) => setOrderId(e.target.value)} /></div>
        <div className="space-y-1.5"><Label htmlFor="t-ph">No. WhatsApp</Label><Input id="t-ph" data-testid="track-phone-input" required value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
        <Button type="submit" data-testid="track-submit-button" disabled={loading}>{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Lacak</Button>
      </form>
      {err && <p className="mt-4 text-sm text-red-700" data-testid="track-error">{err}</p>}
      {o && (
        <div className="mt-6 space-y-4" data-testid="track-result">
          <div className="flex items-center justify-between"><p className="font-semibold">{o.order_id}</p><StatusBadge status={o.status} /></div>
          <Timeline status={o.status} />
          <p className="text-xs text-stone-500">Dipesan {formatDate(o.created_at)}</p>
          {o.status === "pending" && <Link to={`/bayar/${o.order_id}`} className="text-sm text-amber-700 underline">Lanjutkan pembayaran</Link>}
          <OrderSummary o={o} />
        </div>
      )}
    </div>
  );
}
